export const sortForBack = (sort:1 | -1 | undefined) => {
    if(sort === 1) return "asc"
    if(sort === -1) return "desc"
    return ""
  }